((w, d) => {
    const nav = d.querySelector('.MainNav');
    const expandable = d.querySelector('.MainNav__expandable');
    const header = d.querySelector('.Header');
    const button = d.querySelector('.MainNav__menu-button');
    function closeMenu() {
        expandable.classList.remove('MainNav__expandable--active');
        button.setAttribute('aria-expanded', false);
    }

    nav.addEventListener('focusout', (e) => {
        if (e.relatedTarget && !nav.contains(e.relatedTarget)) {
            closeMenu();
        }
    });

    d.addEventListener('click', (e) => {
        if (!header.contains(e.target)) {
            closeMenu();
        }
    });

    nav.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
            closeMenu();
            button.focus();
        }
    });
})(window, document);
